import React from 'react';
import { Text } from '@atlaskit/primitives/compiled';

export const TaskDescriptionTip = ({ children }: { children: React.ReactNode }) => {
	return (
		<Text size="small" color="color.text.subtlest">
			{children}
		</Text>
	);
};
